module.exports = __webpack_public_path__ + "static/media/decoded.07aa6126.jpg";